// Dependencies
import React from 'react'
// import Helpers from '../Helpers.js'
// import {Button} from '@lazarusai/forms-ui-components'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'

// Styles
import '../styles/FullLoadingScreen.css'

// Components
import {
  Animation,
} from '@lazarusai/forms-ui-components'

// Images

function FullLoadingScreen(props) {
  // const [time, _setTime] = useState(0)
  // const timeRef = useRef(0)
  // function setTime(data) {
  //   _setTime(data)
  //   timeRef.current = data
  // }
  // const timeString = Helpers.secondsToTime(timeRef.current)
  // console.log('time string', timeString)
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     console.log('setting time!!', timeRef.current + 1)
  //     setTime(timeRef.current + 1)
  //   }, 1000)
  //   return () => clearInterval(timer)
  // }, [])

  // useEffect(() => {
  //   console.log('time string', timeString)
  // }, [time])

  return (
    <div
      className={'full-loading-screen'}
      style={{
        height: '100%',
        width: '100%',
        backdropFilter: 'blur(7px)',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        position: 'fixed',
        zIndex: 99,
        // display: 'none',
      }}
    >
      {/* <Loader theme={props.theme} /> */}
      <div
        style={{
          position: 'fixed',
          width: '40vw',
          height: '40vh',
          left: '30vw',
          top: '30vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className='standard-animation'>
          <Animation
            animationState={'generating'}
            stopAnimation={false}
            height={'50vh'}
            width={'50vw'}
          />
        </div>
      </div>
      {/* <p
        className={`${stylesLoad['time']}`}
        style={{
          color: 'white',
          position: 'fixed',
          top: '10px',
          right: '10px',
        }}
      >
        {timeString}
      </p> */}
      {/* <Button
        onClick={() => {
          props.storePayload({
            isLoading: false,
            cancelRequest: true,
          })
        }}
        text='Abort'
        theme={props.theme}
        type={10}
        style={{
          position: 'fixed',
          left: '50%',
          transform: 'translate(-50%, 0)',
          bottom: '10px',
          width: '50%',
        }}
      /> */}
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
})

export default connect(
    mapStateToProps, {storePayload},
)(FullLoadingScreen)
